import React from 'react'
import { useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'
import InputsPresetEditForm from './InputsPresetEditForm'

import { useLoadSroiInputsPreset } from '../useLoadSroiInputsPreset'

import { getSroiInputsPresetWasLoadedSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'

import { SROI_INPUTS_PRESET_EDIT } from '../../../../../constants/forms'

const InputsPresetEdit = () => {
  const sroiInputsPresetWasLoaded = useSelector(getSroiInputsPresetWasLoadedSelector)

  useLoadSroiInputsPreset({
    formName: SROI_INPUTS_PRESET_EDIT
  })

  return (
    <FormDrawerWrapper
      formName={SROI_INPUTS_PRESET_EDIT}
      SkeletonFormComponent={SkeletonSingleSectionForm}
      title="Preset inputs"
      isFormLoading={!sroiInputsPresetWasLoaded}
      showOpenButton={true}
      openButtonText={'Preset Inputs'}
    >
      <InputsPresetEditForm />
    </FormDrawerWrapper>
  )
}

export default InputsPresetEdit
